import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, watch } from 'vue';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'RACQFormKitErrorMessage',
  props: {
    node: {},
    errorTitle: {},
    errorMessage: {},
    defaultMessagePlacement: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const nodeRef = computed(() => props.node);

watch(
  () => props.defaultMessagePlacement,
  () => {
    if (nodeRef.value?.context) {
      nodeRef.value.context.defaultMessagePlacement = props.defaultMessagePlacement;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (!_ctx.defaultMessagePlacement && nodeRef.value?.context?.state?.invalid)
    ? (_openBlock(), _createBlock(InformationBox, {
        key: 0,
        title: _ctx.errorTitle,
        description: _ctx.errorMessage,
        type: _unref(InformationBoxTypes).ERROR
      }, null, 8, ["title", "description", "type"]))
    : _createCommentVNode("", true)
}
}

})